import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Courses from "./pages/Courses";
import Ecommerce from "./pages/Ecommerce";
import Consulting from "./pages/Consulting";
import Certification from "./pages/Certification";
import Operations from "./pages/Operations";
import Matrix from "./pages/Matrix";
import IpIncubation from "./pages/IpIncubation";
import Activity from "./pages/Activity";
import Interview from "./pages/Interview";
import TeamExpression from "./pages/TeamExpression";
import WebDev from "./pages/WebDev";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

const routeDefs = [
  { path: "/", element: <Index /> },
  { path: "/courses", element: <Courses /> },
  { path: "/ecommerce", element: <Ecommerce /> },
  { path: "/consulting", element: <Consulting /> },
  { path: "/certification", element: <Certification /> },
  { path: "/operations", element: <Operations /> },
  { path: "/matrix", element: <Matrix /> },
  { path: "/ip-incubation", element: <IpIncubation /> },
  { path: "/activity", element: <Activity /> },
  { path: "/interview", element: <Interview /> },
  { path: "/team-expression", element: <TeamExpression /> },
  { path: "/web-dev", element: <WebDev /> },
  { path: "/contact", element: <Contact /> },
];

const withPrefix = (prefix: string, path: string) => {
  if (!prefix) return path;
  return path === "/" ? prefix : `${prefix}${path}`;
};

const renderRoutes = (prefix: string) =>
  routeDefs.map((route) => (
    <Route key={`${prefix}${route.path}`} path={withPrefix(prefix, route.path)} element={route.element} />
  ));

const App = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          {renderRoutes("")}
          {renderRoutes("/en")}
          <Route path="/en/*" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </QueryClientProvider>
  );
};

export default App;
